var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 32C16.8452 32 15.5 33.3452 15.5 35C15.5 36.6548 16.8452 38 18.5 38C20.1548 38 21.5 36.6548 21.5 35C21.5 33.3452 20.1548 32 18.5 32ZM18.5 36.7103C17.5575 36.7103 16.7897 35.9425 16.7897 35C16.7897 34.0575 17.5575 33.2897 18.5 33.2897C19.4425 33.2897 20.2103 34.0575 20.2103 35C20.2103 35.9425 19.4425 36.7103 18.5 36.7103Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32C30.8452 32 29.5 33.3452 29.5 35C29.5 36.6548 30.8452 38 32.5 38C34.1548 38 35.5 36.6548 35.5 35C35.5 33.3452 34.1548 32 32.5 32ZM32.5 36.7103C31.5575 36.7103 30.7897 35.9425 30.7897 35C30.7897 34.0575 31.5575 33.2897 32.5 33.2897C33.4425 33.2897 34.2103 34.0575 34.2103 35C34.2103 35.9425 33.4425 36.7103 32.5 36.7103Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 5C41.9016 5 40.5221 6.10148 40.1486 7.67734L39.2952 11.2688H25.448C25.444 11.7168 25.4118 12.1586 25.3576 12.5922H38.9819L35.1546 28.6746H16.5181L14.8293 23.1603C14.0152 23.2251 14.3242 23.2231 14.0152 23.2292C14.0152 23.2292 14.0152 23.2292 13.5 23.2397L15.508 30H36.1807L41.4177 7.98885C41.6506 7.00953 42.508 6.32544 43.5 6.32544H47.5V5.00204H43.5V5Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.5C22.5 6.26176 18.2438 2 13.0124 2C7.78099 2 3.58884 6.20176 3.52686 11.3883H2.5L4.19628 13.7612L5.89256 11.3883H4.86983C4.93182 6.9424 8.55992 3.34473 13.0124 3.34473C17.4649 3.34473 21.157 7.0024 21.157 11.5C21.157 15.9976 17.5041 19.6553 13.0124 19.6553C10.4174 19.6553 7.95455 18.3995 6.42355 16.2955L5.33884 17.0879C7.11983 19.5373 9.98967 21 13.0124 21C18.2438 21 22.5 16.7382 22.5 11.5Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6V11.5851L16.4832 15L17.5 14.1277L13.94 11.072V6H12.5Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartHistory);
export default __webpack_public_path__ + "static/media/cart-history.cd6da72f92200ad97d72f3b2840f5f77.svg";
export { ForwardRef as ReactComponent };